import styled, { css } from 'styled-components'
import { Button, LinkButton } from '@sketch/components'

const headerActionButtonCss = css`
  height: 32px;
  padding: 4px 8px;
  padding-left: 10px; /* stylelint-disable-line scales/space */
  font-size: ${({ theme }) => theme.fontSizes.D};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  box-shadow: none;

  &,
  :hover,
  :focus,
  :active {
    color: ${({ theme }) => theme.colors.foreground.secondary.A};
  }

  &[disabled] {
    opacity: 0.5;
  }
`

export const ButtonAction = styled(Button).attrs({ size: '32' })`
  ${headerActionButtonCss}
`

export const LinkAction = styled(LinkButton)`
  ${headerActionButtonCss}
`

export const IconContainer = styled.div`
  width: 16px;
  height: 16px;
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};

  & > * {
    width: 16px;
    height: 16px;
  }
`
